const BANNER_ID = 'csv-override-banner';

const showOverrideBanner = (url) => {
    if (document.getElementById(BANNER_ID)) return;

    const AMBER = '#f5a623';
    const DARK = '#15161b';

    const banner = document.createElement('div');
    banner.id = BANNER_ID;
    banner.style.cssText = 'position:fixed;top:0;left:0;right:0;height:60px;z-index:99999;'
        + 'display:flex;align-items:center;gap:8px;padding:0 12px;'
        + `background:${AMBER};border-bottom:1px solid rgba(0,0,0,.25);`
        + 'font:12px/1 system-ui,sans-serif;';

    const icon = document.createElement('span');
    icon.textContent = '⚠';
    icon.setAttribute('aria-hidden', 'true');
    icon.style.cssText = 'flex:none;font-size:14px;line-height:1;color:#fff;';

    const label = document.createElement('span');
    label.textContent = 'CSV OVERRIDE';
    label.style.cssText = 'flex:none;color:#fff;font-weight:650;letter-spacing:.08em;';

    const sep = document.createElement('span');
    sep.textContent = '·';
    sep.style.cssText = 'flex:none;color:rgba(0,0,0,.35);';

    const urlEl = document.createElement('span');
    urlEl.textContent = url;
    urlEl.style.cssText = 'flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;'
        + `white-space:nowrap;color:${DARK};font-family:ui-monospace,Menlo,Consolas,monospace;`;

    banner.append(icon, label, sep, urlEl);
    document.body.appendChild(banner);
};

export const getCsvUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const queryCsvUrl = params.get('csvUrl');

    if (queryCsvUrl) {
        showOverrideBanner(queryCsvUrl);
        return queryCsvUrl;
    }

    return process.env.REACT_APP_SOURCE_URL || `${process.env.PUBLIC_URL}/assets/source.csv`;
};
